export default __webpack_public_path__ + "static/media/device_access_time.7cacbb8c.svg";